module.exports = __webpack_public_path__ + "img/waterpolo.e3cae7d8.svg";